import * as React from 'react';
import Button from '@mui/material/Button';

export default function BasicButtons() {
  return (
      <Button style={{color: 'black', color: '#464646', fontFamily: 'Arial, Helvetica, sans-serif' }} variant="text">Home</Button>
  );
}
